import { isFeature } from 'Cloud/Application/FeaturesEs6';

/** CLOUDWEB-17351 Баннер в левом нижнем углу про темную тему */
export const themeAsidePromoFeature: boolean | undefined = isFeature('theme-promo') && isFeature('theme-switcher');
